module.exports = __webpack_public_path__ + "static/media/google_play.343fc1e9.png";